module.exports = __webpack_public_path__ + "img/get_app-white-18dp.44263490.svg";